import React from 'react';

import FormControl from './FormControl';

const TextField = React.forwardRef(function (
  { title = null, type, value, ...props },
  ref
) {
  return (
    <FormControl
      title={title || value}
      type={type || 'text'}
      value={value || ''}
      ref={ref}
      {...props}
    />
  );
});

export default TextField;